import SolicitacaoTransferencia from './componentes/SolicitacaoTransferencia.vue';
import SolicitacaoTransferenciaLista from './componentes/SolicitacaoTransferenciaLista.vue';
import SolicitacaoTransferenciaForm from './componentes/SolicitacaoTransferenciaForm.vue';
import SolicitacaoTransferenciaRelatorio from './componentes/SolicitacaoTransferenciaRelatorio.vue';

export default {
  path: '/solicitacao-transferencia',
  component: SolicitacaoTransferencia,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoTransferenciaLista,
      name: 'solicitacao-transferencia',
    },
    {
      path: 'nova',
      component: SolicitacaoTransferenciaForm,
      name: 'solicitacao-transferencia.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoTransferenciaRelatorio,
      name: 'solicitacao-transferencia.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoTransferenciaForm,
      name: 'solicitacao-transferencia.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-transferencia/rotas.js